module.exports = __webpack_public_path__ + "img/fitomat-logo.699cf695.svg";